<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/dMgZ8B/tc-custom/9781466892699.jpg?1731185286814" alt="This image is the cover for the book White Savage"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">White Savage
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A provocative new biography of the man who forged America's alliance with the Iroquois</b><br/><br/>William Johnson was scarcely more than a boy when he left Ireland and his Gaelic, Catholic family to become a Protestant in the service of Britain's North American empire. In New York by 1738, Johnson moved to the frontiers along the Mohawk River, where he established himself as a fur trader and eventually became a landowner with vast estates; served as principal British intermediary with the Iroquois Confederacy; command British, colonial, and Iroquois forces that defeated the French in the battle of Lake George in 1755; and created the first groups of "rangers," who fought like Indians and led the way to the Patriots' victories in the Revolution. <br/><br/>As Fintan O'Toole's superbly researched, colorfully dramatic narrative makes clear, the key to Johnson's signal effectiveness was the style in which he lived as a "white savage." Johnson had two wives, one European, one Mohawk; became fluent in Mohawk; and pioneered the use of Indians as active partners in the making of a new America. O'Toole's masterful use of the extraordinary (often hilariously misspelled) documents written by Irish, Dutch, German, French, and Native American participants in Johnson's drama enlivens the account of this heroic figure's legendary career; it also suggests why Johnson's early multiculturalism unraveled, and why the contradictions of his enterprise created a historical dead end.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Fintan O'Toole
      </h2>
      
      <p class="authorDescription body article"><P><B>Fintan O'Toole</B>, columnist and drama critic for the<I> Irish Times</I>, is the author of seven books, including <I>A Traitor's Kiss </I>(FSG, 1998). His work frequently appears in a number of American magazines. He lives in Dublin, Ireland.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Farrar, Straus and Giroux
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3092a660